import * as actionTypes from './actionTypes';

export const createIOTssidNetworkFailed = (payload) => ({
  type: actionTypes.CREATE_IOT_SSID_NETWORK_FAILED,
  payload
  });
  
  export const createIOTssidNetworkSuccess = () => ({
  type: actionTypes.CREATE_IOT_SSID_NETWORK_SUCCESS
  });

  export const createIOTssidNetwork = (info) => ({
    type: actionTypes.CREATE_IOT_SSID_NETWORK,
    info
 });

 export const resetIOTSsidErrorSuccess = () => {
  return {
    type: actionTypes.RESET_IOT_SSID_ERROR_SUCCESS
  }
}
 export const getIOTssidNetworkDetails = (wifiType) => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_DETAILS,
  wifiType
 });
 export const getIOTssidNetworkDevices = (payload) => ({
  type: actionTypes.GET_IOT_NETWORK_DEVICES,
  payload
 });

 export const getIOTssidNetworkSuccess = (payload) => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_SUCCESS,
  payload
 });

 export const getIOTssidNetworkDevicesSuccess = (payload) => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_DEVICES_SUCCESS,
  payload
 });

 export const getIOTssidNetworkFailed = () => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_FAILED
 });

 export const getIOTssidNetworkDevicesFailed = () => ({
  type: actionTypes.GET_IOT_SSID_NETWORK_DEVICES_FAILED
 });

 export const getallIOTssidnetworkdetails = () => ({
  type: actionTypes.GET_ALL_IOT_SSID_NETWORK_DETAILS
 })

// Networks
export const getNetworks = () => ({ type: actionTypes.GET_NETWORKS });
export const getNetworksSuccess = (data) => ({ type: actionTypes.GET_NETWORKS_SUCCESS, payload: data });
export const getNetworksFail = () => ({ type: actionTypes.GET_NETWORKS_FAIL });
export const setSelectedNetwork = (network) => ({ type: actionTypes.SET_SELECTED_NETWORK, payload: network });
export const getNetworkDevices = (wifiType) => ({ type: actionTypes.GET_NETWORK_DEVICES, payload: wifiType });
export const getNetworkDevicesSuccess = (data) => ({ type: actionTypes.GET_NETWORK_DEVICES_SUCCESS, payload: data });
export const getNetworkDevicesFail = (error) => ({ type: actionTypes.GET_NETWORK_DEVICES_FAIL, payload: error });
export const updateNetwork = (payload) => ({ type: actionTypes.UPDATE_NETWORK, payload });
export const updateNetworkSuccess = () => ({ type: actionTypes.UPDATE_NETWORK_SUCCESS });
export const updateNetworkFail = () => ({ type: actionTypes.UPDATE_NETWORK_FAIL });
export const clearUpdateNetworkError = () => ({ type: actionTypes.CLEAR_UPDATE_NETWORK_ERROR });
export const deleteNetwork = (payload) => ({ type: actionTypes.DELETE_NETWORK, payload });
export const deleteNetworkSuccess = () => ({ type: actionTypes.DELETE_NETWORK_SUCCESS });
export const deleteNetworkFail = () => ({ type: actionTypes.DELETE_NETWORK_FAIL });
